import Http from '../utilities/http';

export class RegisterImporterApi {

  static getCurrent() {
    return Http.get('/register-importer/get-current-user');
  }
}
